/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TryFinishDocumentUploadRequest
 */
export interface TryFinishDocumentUploadRequest {
	/**
	 *
	 * @type {string}
	 * @memberof TryFinishDocumentUploadRequest
	 */
	caseId: string;
}

/**
 * Check if a given object implements the TryFinishDocumentUploadRequest interface.
 */
export function instanceOfTryFinishDocumentUploadRequest(
	value: object
): value is TryFinishDocumentUploadRequest {
	if (!('caseId' in value) || value['caseId'] === undefined) return false;
	return true;
}

export function TryFinishDocumentUploadRequestFromJSON(json: any): TryFinishDocumentUploadRequest {
	return TryFinishDocumentUploadRequestFromJSONTyped(json, false);
}

export function TryFinishDocumentUploadRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): TryFinishDocumentUploadRequest {
	if (json == null) {
		return json;
	}
	return {
		caseId: json['caseId'],
	};
}

export function TryFinishDocumentUploadRequestToJSON(json: any): TryFinishDocumentUploadRequest {
	return TryFinishDocumentUploadRequestToJSONTyped(json, false);
}

export function TryFinishDocumentUploadRequestToJSONTyped(
	value?: TryFinishDocumentUploadRequest | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		caseId: value['caseId'],
	};
}
